/* PsiSpore theme.js - Shopify cosmic theme */
(function () {
  'use strict';

  const PsiSpore = window.PsiSpore || {};
  const routes = PsiSpore.routes || {};
  const strings = PsiSpore.strings || {};

  /* ===== UTILITIES ===== */
  function formatMoney(cents) {
    const format = PsiSpore.moneyFormat || '${{amount}}';
    const value = (cents / 100).toFixed(2);
    return format.replace(/\{\{\s*amount\s*\}\}/, value)
                 .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  function showToast(message) {
    const toast = document.getElementById('toast');
    if (!toast) return;
    const msg = toast.querySelector('[data-toast-message]');
    if (msg) msg.textContent = message;
    toast.classList.add('show');
    clearTimeout(toast._t);
    toast._t = setTimeout(() => toast.classList.remove('show'), 2500);
  }

  /* ===== CART AJAX ===== */
  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(r => r.json());
  }

  function addToCart(formData) {
    return fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    }).then(r => {
      if (!r.ok) return r.json().then(err => { throw err; });
      return r.json();
    });
  }

  function changeCartItem(key, quantity) {
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(r => r.json());
  }

  function updateCartCount(count) {
    const els = document.querySelectorAll('#cartCount, .cart-count');
    els.forEach(el => {
      el.textContent = count;
      el.classList.toggle('has-items', count > 0);
    });
  }

  function renderCartDrawer(cart) {
    const body = document.querySelector('[data-cart-body]');
    const footer = document.querySelector('[data-cart-footer]');
    const empty = document.querySelector('[data-cart-empty]');
    const subtotalEl = document.querySelector('[data-cart-subtotal]');
    if (!body) return;

    if (cart.item_count === 0) {
      if (empty) empty.hidden = false;
      const items = body.querySelector('.cart-drawer-items');
      if (items) items.remove();
      if (footer) footer.hidden = true;
      return;
    }

    if (empty) empty.hidden = true;
    if (footer) footer.hidden = false;
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    let html = '<div class="cart-drawer-items">';
    cart.items.forEach(item => {
      const img = item.image
        ? `<img src="${item.image}" alt="${item.product_title}" width="72" height="72" loading="lazy">`
        : '';
      html += `
        <div class="cart-drawer-item" data-key="${item.key}">
          <div class="cart-drawer-item-image">${img}</div>
          <div class="cart-drawer-item-details">
            <a href="${item.url}" class="cart-drawer-item-title">${item.product_title}</a>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-drawer-item-variant">${item.variant_title}</p>` : ''}
            <p class="cart-drawer-item-price">${formatMoney(item.final_price)}</p>
            <div class="cart-drawer-qty">
              <button type="button" class="qty-btn" data-drawer-decrement aria-label="Decrease">&minus;</button>
              <span class="qty-val">${item.quantity}</span>
              <button type="button" class="qty-btn" data-drawer-increment aria-label="Increase">+</button>
              <button type="button" class="cart-drawer-remove" data-drawer-remove aria-label="Remove">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>
          </div>
        </div>`;
    });
    html += '</div>';

    const existing = body.querySelector('.cart-drawer-items');
    if (existing) existing.remove();
    body.insertAdjacentHTML('beforeend', html);
  }

  function refreshCart() {
    return fetchCart().then(cart => {
      updateCartCount(cart.item_count);
      renderCartDrawer(cart);
      return cart;
    });
  }

  /* ===== CART DRAWER ===== */
  function openCart() {
    const drawer = document.getElementById('cartDrawer');
    if (!drawer) return;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function closeCart() {
    const drawer = document.getElementById('cartDrawer');
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('#cartBtn')) {
      e.preventDefault();
      openCart();
    }
    if (e.target.closest('[data-cart-close]')) {
      closeCart();
    }
  });

  /* ===== ADD TO CART FORMS ===== */
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-product-form], form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();

    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.classList.add('is-loading');
    }

    const formData = new FormData(form);
    addToCart(formData)
      .then(() => refreshCart())
      .then(() => {
        showToast(strings.addedToCart || 'Added to cart');
        openCart();
      })
      .catch(err => {
        showToast(err.description || err.message || 'Unable to add to cart');
      })
      .finally(() => {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.classList.remove('is-loading');
        }
      });
  });

  /* ===== CART DRAWER QTY ===== */
  document.addEventListener('click', (e) => {
    const item = e.target.closest('.cart-drawer-item');
    if (!item) return;
    const key = item.dataset.key;

    if (e.target.closest('[data-drawer-increment]')) {
      const qty = parseInt(item.querySelector('.qty-val').textContent, 10) + 1;
      changeCartItem(key, qty).then(cart => { updateCartCount(cart.item_count); renderCartDrawer(cart); });
    }
    if (e.target.closest('[data-drawer-decrement]')) {
      const qty = parseInt(item.querySelector('.qty-val').textContent, 10) - 1;
      changeCartItem(key, Math.max(0, qty)).then(cart => { updateCartCount(cart.item_count); renderCartDrawer(cart); });
    }
    if (e.target.closest('[data-drawer-remove]')) {
      changeCartItem(key, 0).then(cart => { updateCartCount(cart.item_count); renderCartDrawer(cart); });
    }
  });

  /* ===== CART PAGE QTY ===== */
  document.addEventListener('click', (e) => {
    const decr = e.target.closest('[data-qty-decrement]');
    const incr = e.target.closest('[data-qty-increment]');
    if (!decr && !incr) return;
    const wrap = (decr || incr).closest('.cart-item-qty');
    if (!wrap) return;
    const input = wrap.querySelector('[data-qty-input]');
    if (!input) return;
    const cur = parseInt(input.value, 10) || 0;
    input.value = incr ? cur + 1 : Math.max(0, cur - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ===== PRODUCT THUMBS ===== */
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    const main = document.querySelector('[id^="ProductMainImage-"]');
    if (main) main.src = thumb.dataset.src;
  });

  /* ===== VARIANT PICKER ===== */
  function initProductForm() {
    const form = document.querySelector('.product-form[data-product-form]');
    if (!form) return;
    const jsonEl = document.querySelector('[data-product-json]');
    if (!jsonEl) return;

    let product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    const variantSelect = form.querySelector('[data-variant-select]');
    const optionSelects = form.querySelectorAll('[data-product-option]');
    const addBtn = form.querySelector('[data-add-btn]');
    const addBtnText = form.querySelector('[data-add-btn-text]');
    const priceEl = document.querySelector('.product-price .price-display');

    function findVariant() {
      const selected = Array.from(optionSelects).map(s => s.value);
      return product.variants.find(v => {
        for (let i = 0; i < selected.length; i++) {
          if (v.options[i] !== selected[i]) return false;
        }
        return true;
      });
    }

    function updateUI() {
      const variant = findVariant();
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addBtnText) addBtnText.textContent = strings.unavailable || 'Unavailable';
        return;
      }
      if (variantSelect) variantSelect.value = variant.id;
      if (addBtn) addBtn.disabled = !variant.available;
      if (addBtnText) addBtnText.textContent = variant.available
        ? (strings.addToCart || 'Add to cart')
        : (strings.soldOut || 'Sold out');
      if (priceEl) {
        const now = priceEl.querySelector('.price-now');
        const was = priceEl.querySelector('.price-was');
        if (now) now.textContent = formatMoney(variant.price);
        if (was) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            was.textContent = formatMoney(variant.compare_at_price);
            was.hidden = false;
          } else {
            was.hidden = true;
          }
        }
      }
      // Swap main image if variant has featured image
      if (variant.featured_image && variant.featured_image.src) {
        const main = document.querySelector('[id^="ProductMainImage-"]');
        if (main) main.src = variant.featured_image.src;
      }
    }

    optionSelects.forEach(s => s.addEventListener('change', updateUI));
    updateUI();
  }

  /* ===== AGE GATE ===== */
  function initAgeGate() {
    const gate = document.getElementById('ageGate');
    if (!gate) return;
    if (sessionStorage.getItem('psispore_age_ok') === '1') {
      gate.hidden = true;
      return;
    }
    gate.hidden = false;
    document.body.style.overflow = 'hidden';

    gate.addEventListener('click', (e) => {
      if (e.target.closest('[data-age-confirm]')) {
        sessionStorage.setItem('psispore_age_ok', '1');
        gate.hidden = true;
        document.body.style.overflow = '';
      }
      if (e.target.closest('[data-age-deny]')) {
        window.location.href = 'https://www.google.com';
      }
    });
  }

  /* ===== MOBILE NAV ===== */
  document.addEventListener('click', (e) => {
    if (e.target.closest('#mobileMenuBtn')) {
      const nav = document.getElementById('mobileNav');
      if (nav) {
        nav.classList.add('open');
        nav.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
    }
    if (e.target.closest('[data-mobile-close]')) {
      const nav = document.getElementById('mobileNav');
      if (nav) {
        nav.classList.remove('open');
        nav.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    }
  });

  /* ===== HEADER SCROLL ===== */
  const header = document.getElementById('siteHeader');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 50);
    }, { passive: true });
  }

  /* ===== SCROLL REVEAL ===== */
  function initReveals() {
    if (!('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.reveal').forEach(el => io.observe(el));
  }

  /* ===== STAR FIELD CANVAS ===== */
  function initStars(canvas) {
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let width, height, stars = [];

    function resize() {
      width = canvas.width = canvas.offsetWidth;
      height = canvas.height = canvas.offsetHeight;
    }

    function createStars(count) {
      stars = [];
      for (let i = 0; i < count; i++) {
        stars.push({
          x: Math.random() * width,
          y: Math.random() * height,
          radius: Math.random() * 1.5 + 0.3,
          alpha: Math.random() * 0.8 + 0.2,
          speed: Math.random() * 0.5 + 0.1,
          twinkleSpeed: Math.random() * 0.02 + 0.005,
          twinklePhase: Math.random() * Math.PI * 2,
          color: Math.random() > 0.7
            ? (Math.random() > 0.5 ? '#D946EF' : '#06B6D4')
            : '#ffffff'
        });
      }
    }

    function draw() {
      ctx.clearRect(0, 0, width, height);
      for (let i = 0; i < stars.length; i++) {
        for (let j = i + 1; j < stars.length; j++) {
          const dx = stars[i].x - stars[j].x;
          const dy = stars[i].y - stars[j].y;
          const dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < 100 && stars[i].radius > 1 && stars[j].radius > 1) {
            ctx.beginPath();
            ctx.moveTo(stars[i].x, stars[i].y);
            ctx.lineTo(stars[j].x, stars[j].y);
            ctx.strokeStyle = `rgba(139, 92, 246, ${0.05 * (1 - dist / 100)})`;
            ctx.lineWidth = 0.5;
            ctx.stroke();
          }
        }
      }
      stars.forEach(star => {
        star.twinklePhase += star.twinkleSpeed;
        const twinkle = (Math.sin(star.twinklePhase) + 1) / 2;
        const alpha = star.alpha * (0.5 + twinkle * 0.5);
        ctx.beginPath();
        ctx.arc(star.x, star.y, star.radius, 0, Math.PI * 2);
        ctx.fillStyle = star.color === '#ffffff'
          ? `rgba(255, 255, 255, ${alpha})`
          : star.color === '#D946EF'
            ? `rgba(217, 70, 239, ${alpha})`
            : `rgba(6, 182, 212, ${alpha})`;
        ctx.fill();
        if (star.radius > 1) {
          ctx.beginPath();
          ctx.arc(star.x, star.y, star.radius * 3, 0, Math.PI * 2);
          const glow = ctx.createRadialGradient(star.x, star.y, 0, star.x, star.y, star.radius * 3);
          glow.addColorStop(0, star.color === '#ffffff'
            ? `rgba(255, 255, 255, ${alpha * 0.3})`
            : star.color === '#D946EF'
              ? `rgba(217, 70, 239, ${alpha * 0.3})`
              : `rgba(6, 182, 212, ${alpha * 0.3})`);
          glow.addColorStop(1, 'transparent');
          ctx.fillStyle = glow;
          ctx.fill();
        }
        star.y -= star.speed * 0.15;
        if (star.y < -5) {
          star.y = height + 5;
          star.x = Math.random() * width;
        }
      });
      requestAnimationFrame(draw);
    }

    resize();
    createStars(Math.min(200, Math.floor(width * height / 5000)));
    draw();
    window.addEventListener('resize', () => {
      resize();
      createStars(Math.min(200, Math.floor(width * height / 5000)));
    });
  }

  /* ===== NEWSLETTER ===== */
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('.newsletter-form');
    if (!form) return;
    // Let Shopify handle the post (no preventDefault). Toast on success page.
  });

  /* ===== INIT ===== */
  function init() {
    initAgeGate();
    initProductForm();
    initReveals();
    document.querySelectorAll('#stars-canvas, #stars-canvas-banner').forEach(initStars);
    refreshCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
